import { useContext } from 'react';
import { SubscriptionContext } from '../components/wrappers/SubscriptionProvider';

const useSubscriptionPlan = () => useContext(SubscriptionContext);

export default useSubscriptionPlan;
